'use client';

import React__default from 'react';

function useHash() {
    var _a = React__default.useState(function () { return window.location.hash; }), hash = _a[0], setHash = _a[1];
    var hashChangeHandler = React__default.useCallback(function () {
        setHash(window.location.hash);
    }, []);
    React__default.useEffect(function () {
        window.addEventListener('hashchange', hashChangeHandler);
        return function () {
            window.removeEventListener('hashchange', hashChangeHandler);
        };
    }, []);
    var updateHash = React__default.useCallback(function (newHash) {
        if (newHash !== hash)
            window.location.hash = newHash;
    }, [hash]);
    return [hash, updateHash];
}

export { useHash as default };
//# sourceMappingURL=index.js.map
